export function scoreColor(score, par) {
  if (score == null || Number(score) <= 0 || !par) return null
  const s = Number(score)
  if (s === 1) return '#EC4899'        // hole-in-one / ace — pink, always first
  const diff = s - par
  if (diff <= -3) return '#86EFAC'      // double eagle / albatross — light green
  if (diff === -2) return '#E8B400'     // eagle — gold
  if (diff === -1) return '#D32F2F'     // birdie — red
  if (diff === 0) return null           // par — no color
  if (diff === 1) return '#3B82F6'      // bogey — light blue
  if (diff === 2) return '#F97316'      // double bogey — orange
  return '#374151'                      // triple bogey or worse — gray
}
